import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import ThemePlugin, { applyTheme } from '@/theme'
import '@/theme/theme.scss'
import { setOnAuthError, setOnTokenRefresh } from '@/services/apiClient'
import { reportError } from '@/services/errorReportingApi'

import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
Vue.use(ThemePlugin)

Vue.config.errorHandler = (err, vm, info) => {
  reportError({ message: err.message, stack: err.stack, context: `vue:${info}` })
  console.error(err) // preserve default dev-console visibility
}

window.addEventListener('error', (event) => {
  reportError({ message: event.message, stack: event.error?.stack, context: 'window.onerror' })
})

window.addEventListener('unhandledrejection', (event) => {
  reportError({
    message: event.reason?.message || String(event.reason),
    stack: event.reason?.stack,
    context: 'unhandledrejection',
  })
})

applyTheme(false)

// Must run before the Vue instance is created so the router guard
// can read the persisted username on initial navigation.
store.dispatch("settings/initSettings")
store.dispatch("health/startMonitoring")

setOnAuthError(() => {
  store.dispatch('settings/logout')
  router.push('/login').catch(() => {})
})

setOnTokenRefresh((access, refresh) => {
  store.dispatch('settings/updateTokens', { access, refresh })
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    if (this.$store.getters["settings/accessToken"]) {
      this.$store.dispatch("settings/refreshProfile").catch(() => {})
      this.$store.dispatch("chat/initConversations")
    }
  }
}).$mount('#app')
